import { Select } from "shared/ui/components/Select";

//FIXME: add typings
const SelectField = ({ field, helpers, onChanged, ...restProps }: any) => {
  const handleChange = (value: any) => {
    helpers.setValue(value);

    if (onChanged) {
      onChanged(value);
    }
  };

  return <Select {...field} {...restProps} onChange={handleChange} />;
};

export default SelectField;
